import { useEffect, useState } from 'react';
import { auth } from '../../firebase/firebase';
import { argosApiEntryPoint } from '../../GlobalConfig';
import { Button, LinearProgress, Link } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

interface MostRetractedAuthorsTableProps {
    institutionId: string
    institutionName: string
    onAuthorSelected: (openAlexaAuthorId: string, authorDisplayName: string, institutionId: string | undefined, institutionName: string | undefined, collaborationMode: boolean) => void
}

interface MostRetractedAuthor {
    authorProfileId: string,
    authorName: string,
    retractions: number
}

export default function MostRetractedAuthorsTable({ institutionId, institutionName, onAuthorSelected }: MostRetractedAuthorsTableProps) {

    const [isLoading, setIsLoading] = useState(true)
    const [mostRetractedAuthors, setMostRetractedAuthors] = useState<MostRetractedAuthor[]>([]);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });


    let mostRetractedAuthorsColumn: GridColDef<(MostRetractedAuthor)>[] =
        [
            {
                field: 'authorProfileId', headerName: 'Profile', flex: 0.15,
                renderCell: it => {
                    return <Link href={it.row.authorProfileId} target="_blank"
                    ><img src="/argos/static/images/logos/openalex_logo.png" width='30px' /></Link>
                }
            },
            { field: 'authorName', headerName: 'Author Name', flex: 0.4 },
            {
                field: 'retractions', headerName: 'Retractions', flex: 0.15,
                renderCell: it => {
                    return <Button onClick={() => onAuthorSelected(it.row.authorProfileId, it.row.authorName, institutionId, institutionName, false)}>
                        {it.row.retractions}
                    </Button>
                }
            },
        ];


    function getRowId(row: MostRetractedAuthor) {
        return row.authorProfileId;
    }

    useEffect(() => {

        setIsLoading(true)

        async function fetchData() {
            let authToken = await auth.currentUser?.getIdToken(true)
            let apiPath = "most-retracted-authors"

            fetch(argosApiEntryPoint + '/stats/institutional-summary/' + apiPath + '?institutionId=' + institutionId + "&institutionName=" + institutionName
                , {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json;charset=UTF-8',
                        'Authorization': 'Bearer ' + authToken
                    }
                })
                .then((response) => response.json())
                .then((data: MostRetractedAuthor[]) => {
                    setMostRetractedAuthors(data)
                    setIsLoading(false)
                }
                );
        }
        fetchData()
    }, [institutionId]);

    return (
        <>
            {isLoading && <LinearProgress />}
            {!isLoading &&
                <DataGrid
                    rows={mostRetractedAuthors}
                    columns={mostRetractedAuthorsColumn}
                    getRowId={getRowId}
                    paginationMode="server"
                    onPaginationModelChange={(setPaginationModel)}
                    rowCount={10}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }}
                    columnHeaderHeight={120}
                    pageSizeOptions={[10, 20, 50]}
                    sx={{ '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': { display: 'none' } }}
                />}
        </>
    );
}